// extracted by mini-css-extract-plugin
export default {"loginBox":"LoginArea_loginBox__xY0dp","buttonBox":"LoginArea_buttonBox__kNuUc"};